const UNKNOWN_ASSIGNEE = "Unknown";

/** A provider's name (or email) for an individual assignment, else the pool's name. */
export function getAssigneeName({
  poolName,
  providerFirstName,
  providerLastName,
  providerEmail,
}: {
  poolName: string | null;
  providerFirstName: string | null;
  providerLastName: string | null;
  providerEmail: string | null;
}): string {
  if (poolName) {
    return poolName;
  }
  const fullName = [providerFirstName, providerLastName]
    .filter(Boolean)
    .join(" ");
  return fullName || providerEmail || UNKNOWN_ASSIGNEE;
}
